import dayjs, { Dayjs } from "dayjs";

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import minMax from "dayjs/plugin/minMax";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(minMax);

export function formatDateStringMMDDYYYY(dateStr: string) {
    return dayjs(dateStr).format("MM/DD/YYYY");
}

export function oneMonthAgoDateString() {
    return dayjs().subtract(1, "month").format("YYYY-MM-DD");
}

export function getTodayWithTimeTravel(): Dayjs {
    return window.sessionStorage.getItem("time-travel")
        ? dayjs(window.sessionStorage.getItem("time-travel"))
        : dayjs();
}
